import { useEffect } from "react";
import { GameStatus } from "../../models/GameStatus";
import store, { RootState } from "../../store/store";
import Card from "../Card/Card";
import "./Hand.scss";
import HandMatch from "./HandMatch";
import HandSentence from "./HandSentence";
import { useAppSelector } from "../../hooks/redux";
import { Card as CardModel } from "../../models/Card";
import { previewActions } from "../Card/previewSlice";

export default function Hand() {

  const gameState = store.getState().game;
  const previewState = useAppSelector((state: RootState) => state.cardPreview);

  const player = gameState.player;

  const isSentence = gameState.status === GameStatus.SENTENCE && !!player?.data.isStoryteller;
  const isMatching = gameState.status === GameStatus.MATCH;

  useEffect(() => {
    player?.hand.forEach((it) => {
      const img = new Image();
      img.src = it.src;
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps


  const hiddenHand: CardModel[] = [];

  for (let i = 0; i < gameState.settings.handSize; i++) {
    const card: CardModel = {
      cardId: `${i}`,
      src: gameState.settings.cardBack
    }
    hiddenHand.push(card);
  }

  return (<>

    <div className={previewState.areCardsVisible ? 'hand' : 'hand hidden-cards'}>
      {isSentence &&
        <HandSentence />
      }

      {isMatching &&
        <HandMatch />
      }

      {!isSentence && !isMatching &&
        <div className="table-hand">
          {player?.hand.map((it) => {
            return (
              <Card
                card={it}
                cards={player?.hand}
                key={it.cardId}
                isSelectable={false}
              />
            )
          }
          )}
        </div>
      }

      {!player?.hand &&
        <div className="table-hand">
          {hiddenHand.map((it) => {
            return (
              <Card
                card={it}
                cards={hiddenHand}
                key={it.cardId}
                isSelectable={false}
              />
            )
          }
          )}
        </div>
      }

      <div className="show-hide-icon no-select" onClick={() => store.dispatch(previewActions.toggleHandVisibility())}>
        <img src={previewState.areCardsVisible ? '/hide.png' : '/view.png'} alt="toggle visibility"></img>
      </div>

    </div>
  </>)
}